export default "__VITE_ASSET__Bb$FBM$u__"